// extracted by mini-css-extract-plugin
export default {"melodyVideo":"oL-z","isFullWidth":"pL-z","landingPageVideo":"qL-z","play":"rL-z","iframeVideo":"sL-z","playHidden":"tL-z","fullwidth":"uL-z"};